import api from '@api';
import { call, put, takeEvery, select, SelectEffect } from 'redux-saga/effects';
import {
    validateFileImportFetch as validateFileImportFetchAction,
    validateFileImportFetchSuccess,
    validateFileImportFetchFailure,
    importFilesFetchSuccess,
    importFilesFetchFailure,
} from './reducer';
import {
    FileImportType,
    ImportFileImportResType,
    ImportOrderImportFilesResData,
    ValidateFileImportResType,
} from 'src/types/ordersImport';
import { FileType } from 'src/types/file';
import translate from '@translate';
import { RootStoreType } from 'src/types/store';
import { ValidateOrderType } from 'src/types/ordersImport';
import createGoupsOfArray from 'src/utils/createGoupsOfArray';
import PromisePool from '@supercharge/promise-pool';

const MAX_IMPORT_ORDERS_COUNT = 100;

export function* addFile(action: { type: string; payload: FileType }): any {
    yield put(validateFileImportFetchAction(action.payload));
}

export function* addFileWatch() {
    yield takeEvery('ordersImport/addFile', addFile);
}

const validateFileImportFetchRequest = async (data: string, orderType: string) => {
    const res = await api('post', `api/secure/orders/import-validate`, { data, type: orderType });
    return res.data.data;
};

function* validateFileImportFetch(action: { type: string; payload: { file: FileType; orderType: string } }) {
    try {
        const response: ValidateFileImportResType = yield call((): any =>
            validateFileImportFetchRequest(action.payload.file.data || '', action.payload.orderType)
        );
        yield put(validateFileImportFetchSuccess({ validation: response, file: action.payload.file }));
    } catch (e) {
        yield put(validateFileImportFetchFailure({ ...e, file: action.payload.file }));
    }
}

export function* validateFileImportFetchWatch() {
    yield takeEvery('ordersImport/validateFileImportFetch', validateFileImportFetch);
}

export function selectState<T>(selector: (s: RootStoreType) => T): SelectEffect {
    return select(selector);
}

const importFilesFetchRequest = async (data: any) => {
    const res = await api('post', `api/secure/orders/import-orders`, data);
    return res.data;
};

function* importFilesFetch() {
    try {
        const files: FileImportType[] = yield select((state: RootStoreType) => state.ordersImport.files);
        const allOrders: ValidateOrderType[] = [];
        files
            .filter((file) => !file.imported)
            .forEach((file) => {
                if (file.validation?.orders.length) {
                    allOrders.push(...file.validation?.orders);
                }
            });

        const groups = createGoupsOfArray(allOrders, MAX_IMPORT_ORDERS_COUNT);

        const response: {
            results: {
                data: ImportOrderImportFilesResData[];
                message: string;
                statusCode: number;
            }[];
        } = yield call(() =>
            PromisePool.withConcurrency(1)
                .for(groups)
                .process(async (group) => {
                    return importFilesFetchRequest(group);
                })
        );
        const resultData: ImportOrderImportFilesResData[] = [];
        response.results.forEach((result) => {
            result.data.map((orderResult) => {
                resultData.push(orderResult);
            });
        });

        yield put(
            importFilesFetchSuccess({
                imported: resultData,
                files,
                messageSuccess: { title: translate('orders.message.orderImported') },
            })
        );
    } catch (error) {
        // yield put(importFilesFetchFailure({ errorMessage: e?.response?.data?.message || '' }));
        yield put(importFilesFetchFailure({ error }));
    }
}

export function* importFilesFetchWatch() {
    yield takeEvery('ordersImport/importFilesFetch', importFilesFetch);
}
